import Warning from "@mui/icons-material/Warning";
import { Tooltip, useTheme } from "@mui/material";
import type { ReactNode } from "react";

export interface WarningIconProps {
  "data-testid"?: string;
  severity?: "warning" | "error";
  title?: NonNullable<ReactNode>;
}

export function WarningIcon({
  "data-testid": dataTestId,
  severity = "warning",
  title,
}: WarningIconProps) {
  const theme = useTheme();
  const colorPalette = severity === "warning" ? "primary" : "error";

  return (
    <Tooltip placement="top" title={title ?? ""}>
      <Warning
        data-testid={dataTestId}
        fontSize="small"
        htmlColor={theme.palette[colorPalette].main}
      />
    </Tooltip>
  );
}
